import { TenantResourceService } from '../../api-client-gen';
import { withCancellationSupport } from './utils/withCancellationSupport';

export const getTenantQuery = (tenantKey: string) => ({
  queryKey: ['tenant', tenantKey],
  queryFn: withCancellationSupport(() => TenantResourceService.get(tenantKey)),
});
